import React from 'react';

import {Box, Typography} from '@mui/material';
import {noop} from 'lodash';

import {Carousel} from '@/app/shared-components/Carousel';

import CardThemesCarouselSkeleton from './CardThemesCarouselSkeleton';
import {useActions} from './useActions';

import './styles';

interface CardThemesCarouselProps {
  onCardThemeSelected: (cardTheme: string) => void;
}

const CardThemesCarousel: React.FC<CardThemesCarouselProps> = ({
  onCardThemeSelected = noop,
}) => {
  const {
    cardCategoryThemes,
    isGetCardThemesV2Loading,
    isGetCardThemesV2Error,
    itemPerSlide,
    getCardCategoryLabel,
  } = useActions();

  return (
    <>
      {/* Category Cards Section */}
      <Box className="select-category-theme-container">
        {isGetCardThemesV2Loading ||
        isGetCardThemesV2Error ||
        cardCategoryThemes.length === 0 ? (
          <CardThemesCarouselSkeleton />
        ) : (
          cardCategoryThemes.map((category, index) => (
            <Box
              key={index}
              className="select-card-category">
              <Typography className="category-title">
                {getCardCategoryLabel(category.category)}
              </Typography>
              <Carousel
                items={category.themes}
                itemsPerSlide={itemPerSlide}
                onClickItem={itemId => onCardThemeSelected(itemId)}
              />
            </Box>
          ))
        )}
      </Box>
    </>
  );
};

export default CardThemesCarousel;
